<template>
  <gj-tooltip
      :disabled="isMeaningless(tooltip)"
      :content="tooltip">
    <el-date-picker
        v-bind="$attrs"
        v-on="$listeners"
        :size="mapSize"
        :type="type"
        :unlink-panels="true"
        :placeholder="placeholder"
        :start-placeholder="startPlaceholder"
        :end-placeholder="endPlaceholder"
        :picker-options="pickerOptions"
        :clearable="clearable"
        :style="{width: mapWidth}"
        :class="{'gj-date-picker--font14': font14, 'gj-no-clearable': !clearable}"
        ref="elDatePicker"
    >
    </el-date-picker>
  </gj-tooltip>
</template>

<script>

  import {isMeaningful, isMeaningless} from "../../utils/common";
  import {subMonths} from "date-fns";
  import {font14MixIn, isMeaninglessMixin, tooltipMixin} from "../../minxins";
  import {DATE_SHORTCUTS} from "../../utils/const";

  const sizeMap = {
    'default': 'small',
  };

  export default {
    name: "gj-date-picker",
    mixins: [font14MixIn, tooltipMixin, isMeaninglessMixin],
    props: {
      startPlaceholder:{
        type: String,
        default: '开始日期'
      },
      endPlaceholder:{
        type: String,
        default: '结束日期'
      },
      width: {
        type: String
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default'].indexOf(value) !== -1
        }
      },
      type: {
        type: String,
        default: 'date'
      },
      clearable: {
        type: Boolean,
        default: true
      },
      // type = monthrange 填需要控制的月数，其他的为天数
      maxDayLength: {
        type: Number,
        default: null
      },
      shortcut: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      shortcuts: {
        type: Array,
        default: () => ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'],
      },
      disabledDate: {
        default: null
      }
    },
    data() {
      return {
        pickerOptions: {},
        shortcutsList: [
          {
            text: DATE_SHORTCUTS.today.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.today.date);
            }
          },
          {
            text: DATE_SHORTCUTS.yesterday.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.yesterday.date);
            }
          },
          {
            text: DATE_SHORTCUTS.last7Day.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.last7Day.date);
            }
          },
          {
            text: DATE_SHORTCUTS.last14Day.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.last14Day.date);
            }
          },
          {
            text: DATE_SHORTCUTS.last30Day.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.last30Day.date);
            }
          },
          {
            text: DATE_SHORTCUTS.last60Day.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.last60Day.date);
            }
          },
          {
            text: DATE_SHORTCUTS.last90Day.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.last90Day.date);
            }
          },
          {
            text: DATE_SHORTCUTS.currentMonth.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.currentMonth.date);
            }
          },
          {
            text: DATE_SHORTCUTS.lastMonth.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.lastMonth.date);
            }
          },
          {
            text: DATE_SHORTCUTS.yearToToday.text,
            onClick(picker) {
              picker.$emit('pick', DATE_SHORTCUTS.yearToToday.date);
            }
          }
        ]
      }
    },
    created() {
      this.initPickerOptions();
    },
    watch: {
      shortcut: {
        handler: function (shortcut) {
          if (shortcut) {
            this.initPickerOptions();
          } else {
            this.pickerOptions.shortcuts = null;
          }
        }
      }
    },
    computed: {
      mapSize() {
        return sizeMap[this.size];
      },
      mapWidth() {
        if (isMeaningful(this.width)) {
          return this.width;
        } else if (isMeaningful(this.type) && this.type.includes('range')) {
          return '210px';
        } else {
          return '127px';
        }
      }
    },
    methods: {
      initPickerOptions() {
        const vm = this;
        if (['datetimerange', 'daterange', 'monthrange'].includes(this.type)) {
          this.pickerOptions = {
            disabledDate(time) {
              if (isMeaningless(vm.maxDayLength)) {
                return false;
              }
              if ("monthrange" == vm.type) {
                // subMonths 偏移月份
                return time.getTime() > subMonths(vm.timeOptionRange, vm.maxDayLength * -1) ||
                  time.getTime() < subMonths(vm.timeOptionRange, vm.maxDayLength)
              } else {
                let timeOptionRange = vm.timeOptionRange;
                let secondNum = vm.maxDayLength * 24 * 60 * 60 * 1000;
                if (timeOptionRange) {
                  return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
                }
              }
            },
            onPick(time) {
              //当第一时间选中才设置禁用
              if (time.minDate && !time.maxDate) {
                vm.timeOptionRange = time.minDate;
              }
              if (time.maxDate) {
                vm.timeOptionRange = null;
              }
            }
          };
          if (this.shortcut) {
            this.pickerOptions.shortcuts = this.shortcutsList.filter(e => this.shortcuts.includes(e.text))
          }
        }
        if (isMeaningful(this.disabledDate)) {
          this.pickerOptions = {
            disabledDate: this.disabledDate
          };
        }
      },
      pickerFocus(){
        this.$refs.elDatePicker.focus()
      }
    }
  }
</script>

<style scoped>
  .gj-date-picker--font14 /deep/ .el-input__inner {
    font-size: 14px !important;
  }
  .gj-no-clearable /deep/ .el-input__inner {
    padding-right: 0;
  }
  .gj-no-clearable /deep/ .el-range__close-icon {
    width: 0;
  }
</style>
